module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#rpre"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE MANY EDUCATORS AND")])]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("parents with whom I have talked in recent years have convinced me, by their questions and comments, that the ideas in this book are of great concern to them. The volume itself is a collection of short pieces, many of which have appeared separately in pamphlets, magazines, and books. In some I have made cuts; others I have substantially rewritten; the remainder have been included in their original version. Since this collection may be useful in different ways to many people, it seemed a good idea to make it available as quickly as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of our schools, and many people and things in our schools, are changing rapidly. So are my ideas as well. Thus, I have here and there added a short insertion or afterword when it seemed necessary to take account of important changes, either in education or in my own thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would like to thank the Center for the Study of Democratic Institutions, Doubleday, "), _c('i', [_vm._v("Harper’s Magazine, Life, New York Review of Books, New York Times Magazine, the PTA Magazine, Redbook, ")]), _vm._v("Sterling Institute, and "), _c('i', [_vm._v("Yale Alumni Magazine ")]), _vm._v("who first published some of these pieces and who have made it possible for me to bring them together in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—John Holt"), _c('br'), _vm._v("Berkeley, California")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4736dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface.vue
// module id = 81
// module chunks = 0